// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-popup-wrap{align-items:flex-start;justify-content:flex-start}.modal-tag-users{align-items:flex-start;height:100%;position:relative;width:100%}.modal-tag-users.user-tagging{bottom:0;margin-right:0}.modal-tag-users .user-tagging-drawer{min-height:100%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
